class RiftProductShare extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    this.#abortController = new AbortController();
    const nativeShareButton = this.querySelector('[data-rift-native-share]');

    if (!(nativeShareButton instanceof HTMLButtonElement)) return;

    const canShare = typeof navigator.share === 'function';
    const canCopy = typeof navigator.clipboard?.writeText === 'function';

    if (!canShare && !canCopy) {
      nativeShareButton.closest('.rift-product-share__item')?.remove();
      if (!this.querySelector('.rift-product-share__item')) this.hidden = true;
      return;
    }

    nativeShareButton.addEventListener('click', this.#handleShare, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #handleShare = async () => {
    const title = this.dataset.riftShareTitle || document.title;
    const url = this.dataset.riftShareUrl || window.location.href;

    if (typeof navigator.share === 'function') {
      try {
        await navigator.share({ title, url });
        return;
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      this.#announce(this.dataset.riftCopySuccess || 'Link copied');
    } catch {
      this.#announce(this.dataset.riftShareError || 'Unable to share this product');
    }
  };

  #announce(message) {
    const status = this.querySelector('[data-rift-share-status]');
    if (!(status instanceof HTMLElement)) return;

    status.textContent = '';
    requestAnimationFrame(() => {
      status.textContent = message;
    });
  }
}

if (!customElements.get('rift-product-share')) {
  customElements.define('rift-product-share', RiftProductShare);
}
